import { documentApi } from 'common/modules/ReactShared/data/api/document';
import { INeedsActionsAssignmentsFetchApiResponse } from 'common/modules/ReactShared/data/api/document/types';
import * as Template from '../../_pagination';
import { tAssignmentsTab } from './types';

const FETCHERS: Record<
  tAssignmentsTab,
  (args?: Template.IParams) => Promise<INeedsActionsAssignmentsFetchApiResponse>
> = {
  pending_action: documentApi.fetchPendingAssignments,
  waiting_for_review: documentApi.fetchWaitingForReviewAssignments,
  completed: documentApi.fetchCompletedAssignments,
  failed: documentApi.fetchFailedAssignments
};

export { FETCHERS };
